define(
    [
        'flightjs',
    ],

    function(flight) {
        'use strict';

        return flight.component(adminBarToggle);

        function adminBarToggle() {
            this.after('initialize', function () {
                this.on('click', this.triggerToggle);
                this.on(document, 'brandContainer.ui.adminBarShown', this.setActive);
                this.on(document, 'brandContainer.ui.adminBarHidden', this.setInactive);
            });

            this.triggerToggle = function () {
                this.trigger('brandContainer.ui.adminBarToggleRequested');
            };

            this.setActive = function () {
                this.$node.attr('data-active', true);
            };

            this.setInactive = function () {
                this.$node.removeAttr('data-active');
            };
        }
    }
);



/** WEBPACK FOOTER **
 ** ./~/@99designs/brand-container/lib/ui/admin-bar-toggle.js
 **/